import QueryEvent from './QueryEvent.js';
// import log from 'loglevel';

const queryMap = new WeakMap();
const _ = key => queryMap.get(key) || queryMap.set(key, {}).get(key);

const PID = 121;
const DEFAULT_STREAM_FLUSH_SIZE = 10000;
const DEFAULT_STREAM_FLUSH_INTERVAL = 1000;

class Query extends QueryEvent {
	constructor(msgbus, queryString, resp) {
		super(() => {

		});

		let priv = _(this);

		priv.id = resp.id;
		priv.msgbus = msgbus;
		priv.queryString = queryString;
		priv.count = 0;

		priv.onTrapPaging = (resp) => {
			// status_change 가 아예 안와서 onHead 가 없이 onTail 로 바로 갈수도 있음!
			if(resp.type === 'status_change') {
				_(this).count = resp.count;
				this.done('onStatusChange', resp);

				if(!_(this).isOnHeadSent) {
					this.done('onHead', resp);
					_(this).isOnHeadSent = true;
				}
			}
			else if(resp.type === 'eof') {

				if(resp.hasOwnProperty('error_code')) {
					this.done('onError', resp);
				}
				else {
					_(this).count = resp.total_count;
					this.done('onTail', resp);
				}

				_(this).msgbus.unsubscribe('logdb-query-' +  this.id);
			}
			else {
				// log.warn('unexpected response (paging)', resp);
			}
		};

		priv.onTrapStreaming = (resp) => {
			if(resp.hasOwnProperty('last')) {
				if(resp.last) {
					this.done('onTail', resp);
				}
				else {
					this.done('onRows', resp);
				}
			}
			else {
				// log.warn('unexpected response (streaming)', resp);
			}
		};

		priv.subscribe = (callbackName, onTrap) => {
			return _(this).msgbus.subscribe(callbackName, onTrap.bind(this), PID);
		};
	}

	_requestStartQuery(callbackName, parameter, streaming = false) {
		_(this).subscribe(callbackName,
			(streaming ? _(this).onTrapStreaming : _(this).onTrapPaging)
		).onSuccess(() => {
			_(this).msgbus.send('org.araqne.logdb.msgbus.LogQueryPlugin.startQuery', parameter, PID)
			.onSuccess((resp) => {
				this.done('onStarted', resp);
			});
		});
	}

	startStreamQuery() {
		// log.debug('stream query');
		var callbackName = 'logdb-query-result-' + this.id;

		var parameter = {
			'id': this.id,
			'streaming': true,
			'compression': "none",
			'stream_flush_size': DEFAULT_STREAM_FLUSH_SIZE,
			'stream_flush_interval': DEFAULT_STREAM_FLUSH_INTERVAL
		};

		return this._requestStartQuery(callbackName, parameter, true);
	}

	start(...args) {
		var limit = args[0];
		var callbackName, parameter;
		// log.debug('paging query');
		callbackName = 'logdb-query-' + this.id;

		if(!limit) {
			parameter = {
				'id': this.id
			};
		}
		else {
			parameter = {
				'id': this.id,
				'offset': 0,
				'limit': limit,
				'timeline_limit': 10
			};
		}

		return this._requestStartQuery(callbackName, parameter);
	}

	get count() {
		return _(this).count;
	}

	get queryString() {
		return _(this).queryString;
	}

	get status() {
		return _(this).status;
	}

	get id() {
		return _(this).id;
	}


}

export default Query;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/core/Query.js